import styled, { css, keyframes } from "styled-components";
import { rorateArray, sizeParams } from "./spinner.utils";
const opcityValues = ["0.6", "0.4", "0.2", "1"];
const steps = ["0", "25", "50", "75"];
const getKeyFrames = (index, theme, inverted) => {
    const keyFrames = [];
    let backgroundColor = "";
    if (inverted) {
        backgroundColor = theme.colors.transparentWhite;
    }
    else {
        backgroundColor = theme.colors.transparent15;
    }
    const opacityValues = rorateArray(opcityValues, index);
    opacityValues.forEach((opacityValue, key) => {
        keyFrames.push(`${steps[key]}%  {background-color: rgba(${backgroundColor}, ${opacityValue});}`);
    });
    keyFrames.push(`100% {background-color: rgba(${backgroundColor}, ${opacityValues[0]});}`);
    return keyframes `${keyFrames.join(" ")}`;
};
const animation = ({ theme, inverted, index, animationDuration }) => css `
    ${getKeyFrames(index, theme, inverted)} ${animationDuration}s infinite ease;
  `;
export const Square = styled.div((props) => {
    const { theme, index, inverted, column, row, animationDuration, size } = props;
    return css `
    width: ${sizeParams[size].width};
    height: ${sizeParams[size].height};
    animation: ${animation({ theme, inverted, index, animationDuration })};
    grid-column: ${column};
    grid-row: ${row};
  `;
});
export const SpinnerContainer = styled.div(({ size }) => {
    return css `
    display: grid;
    box-sizing: border-box;
    gap: ${sizeParams[size].gap};
  `;
});
